module.exports = __webpack_public_path__ + "img/trash-hard-o.7c9b3bf4.svg";